import { FC, useEffect, useRef } from "react";
import mermaid from "mermaid";

// Initialize mermaid once
mermaid.initialize({
  startOnLoad: true,
  theme: "dark",
  securityLevel: "loose",
});

interface MermaidDiagramProps {
  content: string;
  id: string;
}

export const MermaidDiagram: FC<MermaidDiagramProps> = ({ content, id }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const renderDiagram = async () => {
      if (containerRef.current) {
        try {
          const { svg } = await mermaid.render(`mermaid-${id}`, content);
          containerRef.current.innerHTML = svg;
        } catch (error) {
          console.error("Failed to render mermaid diagram:", error);
        }
      }
    };
    renderDiagram();
  }, [content, id]);

  return (
    <div className="mermaid" ref={containerRef}>
      {content}
    </div>
  );
};
